import { getAuthToken } from "../../../util/auth";
import { getApiChara } from "../../../util/getApi";
import { json, useRouteLoaderData, redirect } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MedicineItem from "./MedicineItem";
import AuthContext from "../../../store/auth-context";
import { useContext } from "react";

const MedicineDetails = () => {
  const authCtx = useContext(AuthContext);
  const medicineData = useRouteLoaderData('medicine-Info');
  return (
    <>
      <MedicineItem medicineInfo={{ ...medicineData, authCtx }} />
    </>
  );
}

export default MedicineDetails;

export const loader = async ({ params, request }) => {
  const id = params?.MedicineId;
  const token = getAuthToken();
  if (token === null || token === 'EXPIRED') {
    return redirect('/');
  }
  const apiChar = getApiChara();
  const apiUrl = `${apiChar}/medicine/getMedicineById/`;
  try {
    const response = await fetch(apiUrl + id, {
      method: request.method,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw json({ message: "could not get details of medicine" }, { status: 500 });
    } else {
      return response;
    }
  } catch (error) {
    throw new Error("Failed to fetch medicine details.");
  }
};


export async function action({ params, request }) {
  const MedicineId = params?.MedicineId;
  const formData = await request.formData();
  const tenantOrClientId = formData.get('tenantOrClientId');
  const token = getAuthToken();
  if (token === null || token === 'EXPIRED') {
    return redirect('/');
  }
  const apiChar = getApiChara();
  const apiUrl = `${apiChar}/medicine/deleteMedicine?id=${MedicineId}&tenantOrClientId=${tenantOrClientId}`;
  const response = await fetch(apiUrl, {
    method: request.method,
    headers: {
      'Authorization': 'Bearer ' + token
    }
  });
  if (!response.ok) {
    toast.error("Medicine not deleted!");
    throw json({ message: "could not deleted" }, { status: 500 });
  } else {
    const data = response;
    toast.success("Medicine deleted successfully!");
    return redirect('..');
  }
}